import { ButtonMenu, useModal } from "@homebound/beam";
import { useParams } from "react-router";
import {
  createDesignPackagePersonalizationGroupsUrl,
  createDesignPackageRequiredOptionsUrl,
  createDesignPackageUrl,
  createDesignPackageVersionHistoryUrl,
} from "src/RouteUrls";
import { ReadyPlanLikeButtonMenuFragment } from "src/components/ReadyPlanButtonMenu.generated";
import { disableBasedOnPotentialOperation } from "src/routes/components/PotentialOperationsUtils";
import { DesignPackagePruneSlotsModal } from "src/routes/libraries/design-catalog/design-package-configurator/components/DesignPackagePruneSlotsModal";
import { useConfirmDiscardDraftVersionModalButtonMenuItem } from "src/routes/libraries/plan-package/details/components/ConfirmDiscardDraftVersionModal";
import { CopyDesignPackageModal } from "../../CopyDesignPackageModal";

type DesignPackageButtonMenuProps = { designPackage: ReadyPlanLikeButtonMenuFragment };

export function DesignPackageButtonMenu({ designPackage }: DesignPackageButtonMenuProps) {
  const { designPackageVersionId = designPackage.aggregateLatest.id } = useParams<{ designPackageVersionId: string }>();
  const discardDraftMenuItem = useConfirmDiscardDraftVersionModalButtonMenuItem(designPackage, createDesignPackageUrl);
  const { openModal } = useModal();

  return (
    <ButtonMenu
      trigger={{ icon: "verticalDots" }}
      items={[
        ...(designPackageVersionId
          ? [
              {
                label: `${designPackage.canEdit.allowed ? "Edit" : "View"} Required Add-Ons`,
                onClick: createDesignPackageRequiredOptionsUrl(designPackage.id, designPackageVersionId),
              },
            ]
          : []),
        {
          label: "View Personalization Groups",
          onClick: createDesignPackagePersonalizationGroupsUrl(designPackage.id, designPackageVersionId),
        },
        {
          label: "Version History",
          onClick: createDesignPackageVersionHistoryUrl(designPackage.id, designPackageVersionId),
        },
        discardDraftMenuItem,
        {
          label: "Make a Copy",
          onClick: () => openModal({ content: <CopyDesignPackageModal id={designPackage.id} />, size: "lg" }),
        },
        {
          label: "Prune Unused Slots",
          onClick: () =>
            openModal({
              content: (
                <DesignPackagePruneSlotsModal designPackageId={designPackage.id} versionId={designPackageVersionId} />
              ),
              size: "lg",
            }),
          disabled: disableBasedOnPotentialOperation(designPackage.canEdit),
        },
      ]}
    />
  );
}
